export default __webpack_public_path__ + "static/media/Guru-Parampara-09.a69bf3b2.png";